import { CategoryDataType } from ".";

export const ValidateCategoryData = (
  data: CategoryDataType,
  priceData: {
    mon: string;
    tue: string;
    wed: string;
    thu: string;
    fri: string;
    sat: string;
    sun: string;
  },
  pricingData: {
    type: string;
    price: string;
  },
  setError: (a: any) => void,
  setPriceDataError: (a: any) => void,
  duration: any,
  setDurationDataError: any,
  product: any
) => {
  let isError = false;
  if (product === "aqua_zone") {
    if (data.categoryName === "") {
      setError((prevState: any) => ({
        ...prevState,
        categoryName: "Please enter category name",
      }));
      isError = true;
    }

    if (data.status === "") {
      setError((prevState: any) => ({
        ...prevState,
        status: "Please select status",
      }));
      isError = true;
    }

    if (data.isDependent === true) {
      if (!data.dependentProduct) {
        setError((prevState: any) => ({
          ...prevState,
          dependentProduct: "Please select Dependent Product",
        }));
        isError = true;
      }
    }

    if (data.productId === "") {
      setError((prevState: any) => ({
        ...prevState,
        productId: "Please enter product ID",
      }));
      isError = true;
    }

    if (data.aquaGroup === "") {
      setError((prevState: any) => ({
        ...prevState,
        aquaGroup: "Please select category",
      }));
      isError = true;
    }

    if (data.aquaAvailableUnit === "") {
      setError((prevState: any) => ({
        ...prevState,
        aquaAvailableUnit: "Please enter available unit",
      }));
      isError = true;
    }

    if (data.imageUrl.length === 0) {
      setError((prevState: any) => ({
        ...prevState,
        imageUrl: "Please upload image",
      }));
      isError = true;
    }

    if (duration.length <= 0) {
      setDurationDataError((prevState: any) => ({
        ...prevState,
        duration: "Please enter price & duration",
      }));
      isError = true;
    }
  } else {
    if (data.categoryName === "") {
      setError((prevState: any) => ({
        ...prevState,
        categoryName: "Please enter category name",
      }));
      isError = true;
    }
    if (data.status === "") {
      setError((prevState: any) => ({
        ...prevState,
        status: "Please select status",
      }));
      isError = true;
    }
    // if (data.categoryInformation === "") {
    //   setError((prevState: any) => ({
    //     ...prevState,
    //     categoryInformation: "Please enter category information",
    //   }));
    //   isError = true;
    // }

    console.log(product);

    if (data.isDependent === true) {
      if (!data.dependentProduct) {
        setError((prevState: any) => ({
          ...prevState,
          dependentProduct: "Please select Dependent Product",
        }));
        isError = true;
      }
    }

    if (pricingData.type === "single") {
      if (pricingData.price === "") {
        setError((prevState: any) => ({
          ...prevState,
          price: "Please enter price",
        }));
        isError = true;
      }
      if (isNaN(Number(pricingData.price))) {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          mon: "Please enter price in number only",
        }));
        isError = true;
      }
      setPriceDataError((prevState: any) => ({
        ...prevState,
        mon: "",
        tue: "",
        wed: "",
        thu: "",
        fri: "",
        sat: "",
        sun: "",
      }));
    } else if (pricingData.type === "multi") {
      setError((prevState: any) => ({
        ...prevState,
        price: "",
      }));
      if (priceData.mon === "") {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          mon: "Please enter price for Monday",
        }));
        isError = true;
      }
      if (priceData.tue === "") {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          tue: "Please enter price for Tuesday",
        }));
        isError = true;
      }
      if (priceData.wed === "") {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          wed: "Please enter price for Wednesday",
        }));
        isError = true;
      }
      if (priceData.thu === "") {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          thu: "Please enter price for Thursday",
        }));
        isError = true;
      }
      if (priceData.fri === "") {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          fri: "Please enter price for Friday",
        }));
        isError = true;
      }
      if (priceData.sat === "") {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          sat: "Please enter price for Saturday",
        }));
        isError = true;
      }
      if (priceData.sun === "") {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          sun: "Please enter price for Sunday",
        }));
        isError = true;
      }
      if (isNaN(Number(priceData.mon))) {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          mon: "Please enter price in number only",
        }));
        isError = true;
      }
      if (isNaN(Number(priceData.tue))) {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          tue: "Please enter price in number only",
        }));
        isError = true;
      }
      if (isNaN(Number(priceData.wed))) {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          wed: "Please enter price in number only",
        }));
        isError = true;
      }
      if (isNaN(Number(priceData.thu))) {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          thu: "Please enter price in number only",
        }));
        isError = true;
      }
      if (isNaN(Number(priceData.fri))) {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          fri: "Please enter price in number only",
        }));
        isError = true;
      }
      if (isNaN(Number(priceData.sat))) {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          sat: "Please enter price in number only",
        }));
        isError = true;
      }
      if (isNaN(Number(priceData.sun))) {
        setPriceDataError((prevState: any) => ({
          ...prevState,
          sun: "Please enter price in number only",
        }));
        isError = true;
      }
    } else {
      setError((prevState: any) => ({
        ...prevState,
        type: "Please select price type",
      }));
      isError = true;
    }

    if (data.productId === "") {
      setError((prevState: any) => ({
        ...prevState,
        productId: "Please enter product ID",
      }));
      isError = true;
    }
  }
  return isError;
};
